import type { ReactNode } from 'react';
import { Link } from 'react-router';
import { Avatar } from '@/components/Avatar';

/** Cellule « personne » d'un tableau : pastille d'initiales, NOM Prénom (en lien vers sa fiche si to), mention facultative */
export function PersonCell({
  to,
  firstName,
  lastName,
  fullName,
  suffix,
}: {
  /** Sa fiche ; sans fiche accessible, le nom seul */
  to?: string;
  firstName: string;
  lastName: string;
  fullName: string;
  /** Après le nom, en gris (« (vous) ») */
  suffix?: ReactNode;
}) {
  return (
    <td className="px-6 py-4">
      <div className="flex items-center gap-3">
        <Avatar firstName={firstName} lastName={lastName} />
        <p className="font-medium text-slate-900">
          {to ? (
            <Link to={to} className="hover:text-blue-700 hover:underline">
              {fullName}
            </Link>
          ) : (
            <span>{fullName}</span>
          )}
          {suffix && <span className="ml-2 text-xs text-slate-400">{suffix}</span>}
        </p>
      </div>
    </td>
  );
}
